import React from 'react';
import EmailIcon from '@material-ui/icons/Email';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import Colors from '../../../internal-components/Colors';
import Link from '@material-ui/core/Link';
import Button from '../../Button';
import PreviewEngine from '../../engine/PreviewEmailEngine';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2em;
  text-align-last: center;

  h3 {
    color: ${Colors.PRIMARY};
    text-transform: uppercase;
    margin: 0.8em;
  }
`;

const EnvClosed = styled(EmailIcon)`
  && {
    font-size: 5em;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
`;

const Done = styled(CheckCircleIcon)`
  && {
    font-size: 5em;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
`;

const AnimationContainer = styled.div`
  position: relative;
  width: 100%;
  height: 5em;

  .closed-env {
    animation-name: slide-out-blurred-top;
    animation-direction: normal;
    animation-duration: 0.6s;
    animation-delay: 1.2s;
    animation-fill-mode: forwards;
  }

  .done {
    -webkit-transform: scale(0);
    transform: scale(0);

    animation-name: scale-out-center;
    animation-direction: reverse;
    animation-duration: 0.2s;
    animation-delay: 1.4s;
    animation-fill-mode: forwards;
  }

  /* ----------------------------------------------
 * Generated by Animista on 2021-2-21 15:34:35
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation scale-out-center
 * ----------------------------------------
 */
  @-webkit-keyframes scale-out-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }
  }
  @keyframes scale-out-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }
  }

  /* ----------------------------------------------
 * Generated by Animista on 2021-2-21 16:55:55
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation slide-out-blurred-top
 * ----------------------------------------
 */
  @-webkit-keyframes slide-out-blurred-top {
    0% {
      -webkit-transform: translateY(0) scaleY(1) scaleX(1);
      transform: translateY(0) scaleY(1) scaleX(1);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
      -webkit-filter: blur(0);
      filter: blur(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateY(-1000px) scaleY(2) scaleX(0.2);
      transform: translateY(-1000px) scaleY(2) scaleX(0.2);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
      -webkit-filter: blur(40px);
      filter: blur(40px);
      opacity: 0;
    }
  }
  @keyframes slide-out-blurred-top {
    0% {
      -webkit-transform: translateY(0) scaleY(1) scaleX(1);
      transform: translateY(0) scaleY(1) scaleX(1);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
      -webkit-filter: blur(0);
      filter: blur(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateY(-1000px) scaleY(2) scaleX(0.2);
      transform: translateY(-1000px) scaleY(2) scaleX(0.2);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
      -webkit-filter: blur(40px);
      filter: blur(40px);
      opacity: 0;
    }
  }
`;

const Go2DashboardBtn = styled(Button)`
  && {
    margin-top: 0.8em;
  }
`;

const ThankYouView = props => {
  const t = useTranslations();

  return (
    <Container>
      <AnimationContainer>
        {/* <EnvOpen className="open-env" color="primary" /> */}
        <EnvClosed className="closed-env" color="primary" />
        <Done className="done" color="primary" />
      </AnimationContainer>
      <h3>{t('forms.thanks')}</h3>
      <PreviewEngine
        body={props.contentMsg}
        customCSS={
          props.isLinkEnabled || props.isDashboardBtnEnabled
            ? 'margin-bottom : 2rem;'
            : ''
        }
      />
      {props.isLinkEnabled && (
        <Link onClick={props.viewSubmission} sub-id={props.submissionId}>
          {t('forms.thanks.submitted.allowResubmit')}
        </Link>
      )}
      {props.isDashboardBtnEnabled && (
        <Go2DashboardBtn variant="outlined" onClick={props.go2Dashboard}>
          {t('form.submitted.return')}
        </Go2DashboardBtn>
      )}
    </Container>
  );
};

export default ThankYouView;
